import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PlantM = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2.5",
                d: "M55 53c-5-6-14-9-24-9s-17 4-21 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                stroke: color,
                strokeLinecap: "round",
                strokeWidth: "2.5",
                d: "m31 32-4-1M33 32l5-1M32 43V22"
            }),
            /*#__PURE__*/ _jsx("path", {
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2.5",
                d: "M31.934 8.058c-.162.108-5.222 4.494-5.19 7.986.03 3.493 2.157 5.912 4.788 5.936s5.31-1.736 5.213-5.397c-.097-3.66-4.644-8.41-4.811-8.525M25.948 31.032c-.547 2.483-5.467 2.483-9.294.747S9 24.823 9 24.823s5.522-1.456 9.294-.495c4.374 1.116 8.2 4.22 7.654 6.704M38.052 31.032c.547 2.483 5.467 2.483 9.294.747S55 24.823 55 24.823s-5.522-1.456-9.294-.495c-4.374 1.116-8.2 4.22-7.654 6.704"
            })
        ]
    });

//# sourceMappingURL=plant-m.js.map